const routes = {
  path: 'settings',
  component: () => import('@/modules/obu-settings/index.vue'),
  children: [
    {
      path: 'business',
      name: 'obu-settings-business',
      component: () => import('@/modules/obu-settings/ObuSettingsBusiness.vue')
    },
    {
      path: 'documents',
      name: 'obu-settings-documents',
      component: () => import('@/modules/obu-settings/ObuSettingsDocuments.vue'),
      children: [

      ]
    },
    {
      path: 'base',
      component: () => import('@/modules/obu-settings/ObuSettingsBase.vue'),
      name: 'obu-settings-base',
      children: [
        {
          path: 'profile',
          name: 'obu-settings-base-profile',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsProfile.vue')
        },
        {
          path: 'attachments',
          component: () => import('@/modules/obu-settings/ObuSettingsAttachments.vue'),
          children: [{
            path: '',
            name: 'obu-settings-attachments',
            component: () => import('@/modules/obu-settings/_components/ObuSettingsAttachments/ObuSettingsAttachmentsList.vue')
          },
          {
            path: 'add',
            name: 'obu-settings-attachments-create',
            component: () => import('@/modules/obu-settings/_components/ObuSettingsAttachments/ObuSettingsAttachmentsCreate.vue')
          },
          {
            path: ':id',
            name: 'obu-settings-attachments-edit',
            component: () => import('@/modules/obu-settings/_components/ObuSettingsAttachments/ObuSettingsAttachmentsEdit.vue')
          }]
        },
        {
          path: 'letterheads',
          component: () => import('@/modules/obu-settings/ObuSettingsLetterHeads.vue'),
          children: [
            {
              path: '',
              name: 'obu-settings-base-letterheads',
              component: () => import('@/modules/obu-settings/_components/ObuSettingsLetterHeads/ObuSettingsLetterHeadsList.vue')
            },
            {
              path: 'add',
              name: 'obu-settings-base-letterheads-create',
              component: () => import('@/modules/obu-settings/_components/ObuSettingsLetterHeads/ObuSettingsLetterHeadsCreate.vue')
            },
            {
              path: ':id',
              name: 'obu-settings-base-letterheads-edit',
              component: () => import('@/modules/obu-settings/_components/ObuSettingsLetterHeads/ObuSettingsLetterHeadsEdit.vue')
            },
            {
              path: 'fonts',
              component: () => import('@/modules/obu-settings/ObuSettingsLetterHeadFonts.vue'),
              children: [
                {
                  path: '',
                  name: 'obu-settings-base-letterheads-fonts',
                  component: () => import('@/modules/obu-settings/_components/ObuSettingsLetterHeadFonts/ObuSettingsLetterHeadFontsList.vue')
                },
                {
                  path: 'add',
                  name: 'obu-settings-base-letterheads-fonts-add',
                  component: () => import('@/modules/obu-settings/_components/ObuSettingsLetterHeadFonts/ObuSettingsLetterHeadFontsEdit.vue')
                },
                {
                  path: ':id/edit',
                  name: 'obu-settings-base-letterheads-fonts-edit',
                  component: () => import('@/modules/obu-settings/_components/ObuSettingsLetterHeadFonts/ObuSettingsLetterHeadFontsEdit.vue')
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: 'calendar',
      component: () => import('@/modules/obu-settings/ObuSettingsCalendar.vue'),
      name: 'obu-settings-calendar',
      children: [
        {
          path: 'base',
          name: 'obu-settings-calendar-base',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsCalendarBase/ObuSettingsCalendarBase.vue')
        },
        {
          path: 'base/settings',
          name: 'obu-settings-calendar-base-settings',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsCalendarBase/ObuSettingsCalendarBase.vue')
        },
        {
          path: 'base/booking-types',
          name: 'obu-settings-calendar-base-booking-types',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsBookingTypes/ObuSettingsBookingTypesList.vue')
        },
        {
          path: 'base/booking-types/:id/edit',
          name: 'obu-settings-calendar-booking-types-edit',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsBookingTypes/ObuSettingsBookingTypesEdit.vue')
        },
        {
          path: 'seasons',
          name: 'obu-settings-seasons',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsSeasons/ObuSettingsSeasonsList.vue')
        },
        {
          path: 'seasons/add',
          name: 'obu-settings-seasons-add',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsSeasons/ObuSettingsSeasonsEdit.vue')
        },
        {
          path: 'seasons/:id/edit',
          name: 'obu-settings-seasons-edit',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsSeasons/ObuSettingsSeasonsEdit.vue')
        }
      ]
    },
    {
      path: 'inquiries',
      component: () => import('@/modules/obu-settings/ObuSettingsInquiries.vue'),
      children: [
        {
          path: 'templates',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsInquiries/ObuSettingsInquiriesTemplates.vue'),
          children: [{
            path: '',
            name: 'obu-settings-inquiries-templates',
            component: () => import('@/modules/obu-settings/_components/ObuSettingsInquiries/ObuSettingsInquiriesTemplatesList.vue')
          },
          {
            path: ':id',
            name: 'obu-settings-inquiries-templates-edit',
            component: () => import('@/modules/obu-settings/_components/ObuSettingsInquiries/ObuSettingsInquiriesTemplatesEdit.vue')
          }
          ]
        }
      ]
    },
    {
      path: 'api',
      component: () => import('@/modules/obu-settings/ObuSettingsApi.vue'),
      children: [
        {
          path: 'api-tokens',
          name: 'obu-settings-api-tokens',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsApiToken/ObuSettingsApiTokenList.vue')
        },
        {
          path: 'gsi',
          name: 'obu-settings-api-gsi',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsGsi/ObuSettingsGsi.vue')
        },
        {
          path: 'api-tokens/:id',
          name: 'obu-settings-api-tokens-details',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsApiToken/ObuSettingsApiTokenDetails.vue')
        },
        {
          path: 'widgets',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsWidgets/ObuSettingsWidgets.vue'),
          children: [{
            path: '',
            name: 'obu-settings-widgets',
            component: () => import('@/modules/obu-settings/_components/ObuSettingsWidgets/ObuSettingsWidgetsList.vue')
          },
          {
            path: ':type',
            name: 'obu-settings-widgets-add',
            component: () => import('@/modules/obu-settings/_components/ObuSettingsWidgets/ObuSettingsWidgetsEdit.vue')
          },
          {
            path: ':id',
            name: 'obu-settings-widgets-details',
            component: () => import('@/modules/obu-settings/_components/ObuSettingsWidgets/ObuSettingsWidgetsDetails.vue')
          },
          {
            path: ':id/edit',
            name: 'obu-settings-widgets-edit',
            component: () => import('@/modules/obu-settings/_components/ObuSettingsWidgets/ObuSettingsWidgetsEdit.vue')
          }
          ]
        }
      ]
    },

    {
      path: 'documents',
      name: 'obu-settings-documents',
      component: () => import('@/modules/obu-settings/ObuSettingsDocuments.vue'),
      children: [
        {
          path: 'content',
          name: 'obu-settings-documents-content',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsDocumentsContent/ObuSettingsDocumentsContent.vue'),
          children: [
            {
              path: ':id/:cid?',
              name: 'obu-settings-documents-content-edit',
              component: () => import('@/modules/obu-settings/_components/ObuSettingsDocumentsContent/ObuSettingsDocumentsContentEdit.vue')
            }
          ]
        },
        {
          path: 'number-ranges',
          name: 'obu-settings-documents-number-range',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsDocumentsContent/ObuSettingsDocumentsNumberRanges.vue')
        },
        {
          path: 'number-ranges/add',
          name: 'obu-settings-documents-number-range-add',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsDocumentsContent/ObuSettingsDocumentsNumberRangesEdit.vue')
        },
        {
          path: 'number-ranges/:id',
          name: 'obu-settings-documents-number-range-edit',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsDocumentsContent/ObuSettingsDocumentsNumberRangesEdit.vue')
        }

      ]
    },
    {
      path: 'notifications',
      name: 'obu-settings-notifications',
      component: () => import('@/modules/obu-settings/ObuSettingsMail.vue')
    },
    {
      path: 'mails',
      name: 'obu-settings-mails',
      component: () => import('@/modules/obu-settings/ObuSettingsMail.vue'),
      children: [
        {
          path: 'layout',
          name: 'obu-settings-mails-layout',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsMailsLayout/ObuSettingsMailsLayoutList.vue')
        },
        {
          path: 'layout/:id',
          name: 'obu-settings-mails-layout-edit',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsMailsLayout/ObuSettingsMailsLayoutEdit.vue')
        },
        {
          path: 'signature',
          name: 'obu-settings-mails-signature',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsMailsSignature/ObuSettingsMailsSignature.vue')
        },
        {
          path: 'smtp',
          name: 'obu-settings-mails-stmp',
          component: () => import('@/modules/obu-settings/_components/ObuSettingsMailsSmtp/ObuSettingsMailsSmtp.vue')
        }
      ]
    }
  ]
}

export default routes
